import React from 'react';

import { styled } from '@linaria/react';
import { useTheme, ITheme } from 'src/theme';

const ButtonElement = styled.button<ButtonProps>`
	background-color: ${props =>
		(props.disabled) ? props.theme?.colors.grey[700] : 
		(props.variant === 'default' ||
		(props.variant === 'input')) ? props.theme?.colors.primary : props.theme?.colors.white
	};
	border: 1px solid ${props =>
		(props.disabled) ? props.theme?.colors.grey[700] : 
		(props.variant === 'default' ||
		(props.variant === 'input')) ? props.theme?.colors.primary : (props.variant === 'secondary' ?  props.theme?.colors.primary : props.theme?.colors.grey[700])
	};
	border-radius: 4px;
  box-sizing: border-box; -webkit-box-sizing: border-box;
	color: ${props => (props.disabled) ? props.theme?.colors.grey[300] : (props.variant === 'secondary' ?  props.theme?.colors.primary : props.theme?.colors.white)};
	cursor: ${props => (props.disabled) ? 'default' : 'pointer'};
	display: ${props => (props.display === 'inline') ? 'inline-block' : 'block'};
	font-family: ${props => props.theme?.fontFamily + ''};
	font-size: 16px;
	font-weight: bold;
	letter-spacing: -0.1px;
	line-height: 24px;
  margin: ${props => typeof props.margin === 'number' ? `${props.margin}px` : props.margin};
	outline: 0;
	padding: ${props => (props.variant === 'input') ? '12px 30px' : '15px 30px'};
	width: ${props =>
		(props.display === 'block') ? '100%' :
		(props.width) ? props.width : 'auto'
	};
	user-select: none; -webkit-user-select: none; -webkit-touch-callout: none;
	transition: background-color .35s,border-color .35s,color .35s;
	&:hover {
		background-color: ${props =>
			(props.disabled) ? props.theme?.colors.grey[700] : (props.variant === 'secondary' ? props.theme?.colors.red[600] : props.theme?.colors.red[600])
		};
		border: 1px solid ${props =>
			(props.disabled) ? props.theme?.colors.grey[700] : props.theme?.colors.red[600]
		};
		color: ${props => (props.disabled) ? props.theme?.colors.grey[300] : props.theme?.colors.white};
		transition: background-color .35s,border-color .35s,color .35s;
	}
`;

export interface ButtonProps {
	variant?: 'default' | 'secondary' | 'input';
	display?: 'inline' | 'block';
	disabled?: boolean;
	width?: string;
	label?: string;
	theme?: ITheme;
	onClick?: () => void;
	margin: string | number;
}

const Button = ({
	variant,
	display,
	margin,
	width,
	label,
	onClick,
	...props
}: ButtonProps) => {
	const theme: ITheme = useTheme();
	return (
		<ButtonElement
			margin={margin}
			variant={variant}
			display={display}
			theme={theme}
			onClick={onClick}
			{...props}>
			{label}
		</ButtonElement>
	);
};

Button.defaultProps = {
	variant: 'default',
	display: 'block',
	margin: '0 0 30px',
}

export { Button }